import { render, staticRenderFns } from "./dialogDefault.vue?vue&type=template&id=7ff1e6ca&scoped=true"
import script from "./dialogDefault.vue?vue&type=script&lang=js"
export * from "./dialogDefault.vue?vue&type=script&lang=js"
import style0 from "./dialogDefault.vue?vue&type=style&index=0&id=7ff1e6ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff1e6ca",
  null
  
)

export default component.exports